// js
import React from 'react';
import PropTypes from 'prop-types';


const ConfiguredItemTitleInput = ({ configuredItem, customTitle, onChange }) => {

  if (customTitle !== null) {
    return (
      <input
        className='configured-item-title-input'
        type='text'
        value={customTitle}
        onChange={onChange}
      />
    );
  }

  // Split title into title and subtitle so we can make the title bold
  let [title, subtitle] = configuredItem.title.split(' - ');

  if (!subtitle && title.indexOf('(') > 0) {
    // We originally split at the dash, but some titles don't have a dash.
    // Just stuff in parentheses so we grab that part and make it the subtitle.
    [title, subtitle] = title.split('(');
    subtitle = '(' + subtitle;
  }

  return (
    <span>
      {title} {subtitle ? ' - ' + subtitle : ''}
    </span>
  );
};

ConfiguredItemTitleInput.propTypes = {
  configuredItem: PropTypes.object.isRequired,
  customTitle: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

export default ConfiguredItemTitleInput;



// WEBPACK FOOTER //
// ./src/components/sources/ConfiguredItemTitleInput.js